import Hero from "../Components/Hero";
import About from "../Components/About";
import Vm from "../Components/Vm";
import BusinessHighlight from "../Components/Businesshl";
import Service from "../Components/Service";
import Achievements from "../Components/Achievements";

const Homepage = () => {
  return (
    <>
      <section id="home">
        <Hero />
      </section>

      <section id="about">
        <About />
      </section>

      <section id="Vm">
        <Vm />
      </section>

      <section id="businesshighlight">
        <BusinessHighlight />
    </section>

    <section id="Service">
      <Service />
    </section>

    <section id="Achievements">
      <Achievements />
    </section>
    </>
  );
};

export default Homepage;